import { useId } from "react";
import { Props_SnippetImageCards } from "./ImageCards.props";
import SnippetLink from "../Shared/Link/Link";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetImageCards = (props: Props_SnippetImageCards) => {
    const { heading, repeatable_card, link } = props;

    const classHeadingVisibility: string = heading.visibility?.value ? 'snippet-image-cards__heading--visible' : 'snippet-image-cards__heading--hidden'
    const hasLink = !!(link.linkHref?.value && link.linkText?.value);
    const id = useId();
    
    return (
        <section className="snippet-image-cards">
            <div className="snippet-image-cards__container">
                <h2 className={`snippet-image-cards__heading ${classHeadingVisibility}`}>
                    {heading.content.value}
                </h2>

                <div className="snippet-image-cards__container-cards">
                    {repeatable_card.map((card, index) => {
                        const stripeColor = card.stripeColor?.value || "transparent";
                        return (
                            <article key={`image-card-${id}-${index}`} className="snippet-image-cards__card">
                                <div className="snippet-image-cards__card-media">
                                    {card.image?.value && (
                                        <img
                                            loading="lazy"
                                            src={card.image.value}
                                            alt={card.imageAlt?.value || ""}
                                            className="snippet-image-cards__card-image"
                                            width="135"
                                            height="140"
                                        />
                                    )}
                                    <span
                                        className={`snippet-image-cards__card-stripe snippet-image-cards__card-stripe--${stripeColor}`}
                                        aria-hidden="true"
                                    />
                                </div>
                                <div className="snippet-image-cards__card-container">
                                    {card.heading?.value && (
                                        <h3 className="snippet-image-cards__card-heading">{card.heading.value}</h3>
                                    )}
                                    {card.content?.value && (
                                        <div className="snippet-image-cards__card-content">
                                            {CompileMarkdown(card.content.value)}
                                        </div>
                                    )}
                                </div>
                            </article>
                        );
                    })}
                </div>

                { hasLink && (
                    <div className="snippet-image-cards__container-link">
                        <SnippetLink
                            linkStyles={link.linkStyle?.value}
                            className="snippet-image-cards__link"
                            url={link.linkHref?.value}
                            openInNewTab={!!link.linkTarget?.value}
                            rel={link.linkTarget?.value ? "noopener noreferrer" : undefined}
                            aria-label={link.linkAriaLabel?.value || link.linkText?.value}
                        >
                            {link.linkText?.value}
                        </SnippetLink>
                    </div>
                )}
            </div>
        </section>
    );
};

export default SnippetImageCards;
